import { Component } from '@angular/core';
import { catchError, of, take } from 'rxjs';
import { DocksModel } from 'src/app/models/DocksModel';
import { KDService } from 'src/app/services/KD/kd.service';

@Component({
  selector: 'app-kd',
  templateUrl: './kd.component.html',
  styleUrls: ['./kd.component.css']
})
export class KDComponent {
  KdDocks: DocksModel[] = []
  dateInterval: any
  updateInterval: any

  private readonly DEFAULT_COLOR = '#FFF'
  private readonly ACTIVE_COLOR = '#3CB371'
  private readonly INACTIVE_COLOR = '#FF2340'

  Date = Date.now();

  constructor(private kdService: KDService,) { }


  ngOnInit() {
    this.updateData();
    this.dateInterval = setInterval(() => {
      this.updateData();
    }, 5000);
  }

  updateData(): void {
    this.kdService.getKDDocksData().pipe
      (take(1),
        catchError(() => {
          return of({ kdDocks: [] })
        })
      ).subscribe(
        (response) => {
          this.KdDocks = response.kdDocks.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }));
        }
      )
  }

  ngOnDestroy() {
    clearInterval(this.dateInterval);
    clearInterval(this.updateInterval);
  }

  //* ---------------------- BOTÕES DOCAS ---------------------- *//

  public statusDocks(docks: number): string {

    const dock = this.KdDocks.find((t) => t.id == docks);
    if (this.isDockValidAndActive(dock)) {
      switch (dock?.truck) {
        case 0:
          return this.DEFAULT_COLOR
        case 1:
          return this.ACTIVE_COLOR
        default:
          return "Valor no campo 'Truck' inválido"
      }
    } return this.INACTIVE_COLOR
  }

  private isDockValidAndActive(dock: any): boolean {
    return dock && dock.truck !== undefined && dock.status && dock.active == 1
  }

}
